"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _helpers = require("./helpers/helpers");
var _Overlay = _interopRequireDefault(require("react-bootstrap/lib/Overlay"));
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var DropDownBtn = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    targetRef = _useState4[0],
    setTargetRef = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    containerRef = _useState6[0],
    setContainerRef = _useState6[1];
  var containerClassName = props.containerClassName,
    buttonId = props.buttonId,
    buttonClassName = props.buttonClassName,
    buttonDataValue = props.buttonDataValue,
    buttonShownValue = props.buttonShownValue,
    buttonChildren = props.buttonChildren,
    children = props.children,
    mobileViewOff = props.mobileViewOff,
    style = props.style,
    openOnLoad = props.openOnLoad;
  (0, _react.useEffect)(function () {
    if (openOnLoad) {
      setShow(true);
    }
  }, []);
  var toggleShow = function toggleShow() {
    setShow(!show);
  };
  var hideDropDown = function hideDropDown() {
    var onHideFn = props.onHideFn;
    setShow(false);
    if ((0, _isFunction.default)(onHideFn)) onHideFn();
  };
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      hideDropDown: hideDropDown
    };
  });
  var isMobile = _helpers.Helpers.isMobile();
  var listComponent = /*#__PURE__*/_react.default.cloneElement(children, {
    listToggle: toggleShow
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: setContainerRef,
    className: "dropdown-container ".concat(containerClassName || '')
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    id: buttonId || null,
    className: "btn btn-default btn-block ".concat(buttonClassName || '', " btn-outlined-light"),
    onClick: toggleShow,
    style: style,
    ref: setTargetRef
  }, buttonChildren ? /*#__PURE__*/_react.default.cloneElement(buttonChildren, {
    show: show
  }) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "dropdown-value ellipsis",
    "data-value": buttonDataValue
  }, buttonShownValue), /*#__PURE__*/_react.default.createElement("span", {
    className: show ? 'arrow up' : 'arrow'
  }))), isMobile && !mobileViewOff ? listComponent : targetRef && /*#__PURE__*/_react.default.createElement(_Overlay.default, {
    container: containerRef,
    show: show,
    placement: "bottom",
    target: targetRef,
    rootClose: true,
    onHide: hideDropDown
  }, listComponent));
});
DropDownBtn.propTypes = {
  buttonId: _propTypes.default.string,
  buttonDataValue: _propTypes.default.string,
  buttonShownValue: _propTypes.default.string,
  containerClassName: _propTypes.default.string,
  buttonClassName: _propTypes.default.string,
  buttonChildren: _propTypes.default.object.isRequired,
  children: _propTypes.default.object.isRequired,
  mobileViewOff: _propTypes.default.bool,
  style: _propTypes.default.object,
  onHideFn: _propTypes.default.func,
  openOnLoad: _propTypes.default.bool
};
exports.DropDownBtn = DropDownBtn;